import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { getApi } from '../../api/endpoints.js';
import Page from "../Page.js";
import FormPartial from "./FormPartial.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ComplaintCategory from '../../models/ComplaintCategory.js';
import { toast } from 'react-toastify';

const New = (props) => {
  const [complaintCategory, setComplaintCategory] = useState(new ComplaintCategory().toStateJson());
  const [createApi] = getApi('createCategory');
  const navigate = useNavigate();
  let complaintCategoryObj = new ComplaintCategory();

  const createRecord = async (params) => {
    try {
      await createApi(params).unwrap();
        navigate("/categories");
        toast.success("Created Successfully");
    } catch(error) {
      complaintCategoryObj.set_api_errors(error.data.data.errors);
    }
  }

  const onCreateClick = () => {
    try{
    createRecord((new ComplaintCategory(complaintCategory)).toApiJson());
    } catch(error){
      setComplaintCategory(new ComplaintCategory(complaintCategory));
    }
  }

  const onBackClick = () => {
    navigate("/categories");
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.NewComplaintCategoryPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Categories", url: '/categories' }, { label: "Add New Category" }]}
    className={'add-ComplaintCategory-page'}
  >
    <PageContentWrapper contentHeading={"Add New Category"}>
      <div className='m-3'>
        <form className="row g-4" autoComplete="off">
          <FormPartial complaintCategory={complaintCategory} setComplaintCategory={setComplaintCategory}/>
          <div className='mb-4 col-md-12'>
            <div>
              <button type="button" className="btn btn-voltup-theme" onClick={onBackClick} style={{ float: 'inline-start' }}>
                Back
              </button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={onCreateClick}>
                Add Category
              </button>
            </div>
          </div>
        </form>
      </div>
    </PageContentWrapper>
  </Page>
};

export default New;
